// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"190":"docs","191":"oxc-home","208":"oxc-me"}[chunkId] || chunkId) + "." + {"190":"ad0a67f6","191":"97d47c70","208":"6b76bd0f","865":"415eb76e"}[chunkId] + ".js";
};